import useGlobalContext from "../../hooks/use-context";
import React, { useState, useCallback, useRef } from "react";
import { useClickAway } from "react-use";

const NiceSelect = ({
  options,
  defaultCurrent,
  placeholder,
  className,
  onChange,
  name,
}) => {
  const [open, setOpen] = useState(false);
  // const { setNiceSelectData } = useGlobalContext();
  const [niceSelectData, setNiceSelectData] = useState("0")
  const [current, setCurrent] = useState(options[defaultCurrent]);
  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  const ref = useRef(null);
  useClickAway(ref, onClose);

  const currentHandler = (item) => {
    setCurrent(item);
    onChange(item, name);
    setNiceSelectData(item?.optionName);
    onClose();
  };

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setOpen((prev) => !prev);
    }
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className={`nice-select ${className || ""} ${open ? "open" : ""}`}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyPress}
      ref={ref}
    >
      <span className="current">{current?.optionName || placeholder}</span>
      <ul
        className="list"
        role="menubar"
        onClick={stopPropagation}
        onKeyDown={stopPropagation}
      >
        {options?.map((item) => (
          <li
            key={item.id}
            data-value={item.id}
            className={`option ${item.id === current?.id ? "selected focus" : ""}`}
            role="menuitem"
            onClick={() => currentHandler(item)}
            onKeyDown={(e) => {
              stopPropagation(e);
            }}
          >
            {item.optionName}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NiceSelect;
